import React, { FC, KeyboardEvent, useCallback } from 'react';
import { stylesheet } from 'astroturf/react';

import Modal from 'js/components/modals/Modal';
import {
  PremiumReaderProductsModal,
  Props,
} from 'js/bulk_download/reader_products_modal/premium_reader_products_modal';

const styles = stylesheet`
  .backdrop {
    align-items: flex-start;

    @include for-tablet-up {
      align-items: center;
    }
  }

  .modal {
    border-radius: 2px;
    padding: 0;
    margin: 0;
    width: 100%;
    max-width: 100%;

    :global(.all-products-modal-container.premium-reader-modal) {
      max-width: 100%;
    }

    :global(.premium-reader-modal-button-container button) {
      background-color: $ds-primary-blue;
    }

    @include for-tablet-up {
      width: unset;
      max-width: unset;
    }
  }
`;

const BulkDownloadModal: FC<Props> = (props) => {
  const { closeModal } = props;
  const closeModalOnEscape = useCallback(
    (e: KeyboardEvent<HTMLInputElement>) => {
      if (e.key === 'Escape') {
        closeModal();
      }
    },
    [closeModal],
  );

  return (
    <Modal
      backdropClassName={styles.backdrop}
      className={styles.modal}
      onClose={closeModal}
      containerProps={{
        onKeyDown: closeModalOnEscape,
      }}
    >
      <PremiumReaderProductsModal {...props} />
    </Modal>
  );
};

export default BulkDownloadModal;
